import { Typography, TypographyProps } from "@mui/material";

export const NaCell = (props: TypographyProps) => (
  <Typography
    {...props}
    className={"empty-na " + (props.className || "")}
    children={props.children || "N/A"}
  />
);
